import { useSubaccounts } from "../../../hooks/api/admin/useSubaccounts";
import { shortenAddress } from "../../../utils/strings";
import { subaccountLabel, useAccountLabel } from "../../shared/SubaccountIndicator";
import {
  MutedText,
  SubaccountName,
  SubaccountTable,
  SubaccountTableRow,
} from "../../shared/SubaccountIndicator/style";
import { StatTitle } from "./style";

interface ISubaccountStatsProps {
  account?: string;
  isMobile?: boolean;
}

/**
 * Lists a master account's subaccounts, or links a subaccount back to its master.
 */
export function SubaccountStats({ account, isMobile }: ISubaccountStatsProps) {
  const getLabel = useAccountLabel();
  const { parent, subaccounts, isSubaccount, isMaster } = useSubaccounts(account);

  if (isSubaccount && parent) {
    return (
      <>
        <StatTitle isMobile={isMobile}>Master Account</StatTitle>
        <SubaccountTable isMobile={isMobile}>
          <SubaccountTableRow to={`/account/${parent}`}>
            <SubaccountName>
              <span>{getLabel(parent)}</span>
              <span>{parent}</span>
            </SubaccountName>
            <span />
            <MutedText>Open ↗</MutedText>
          </SubaccountTableRow>
        </SubaccountTable>
      </>
    );
  }

  if (!isMaster) return null;

  return (
    <>
      <StatTitle isMobile={isMobile}>Subaccounts ({subaccounts.length})</StatTitle>
      <SubaccountTable isMobile={isMobile}>
        {subaccounts.map((sub) => (
          <SubaccountTableRow key={sub.subaccount} to={`/account/${sub.subaccount}`}>
            <SubaccountName>
              <span>
                {subaccountLabel(sub)}
                {sub.archived ? <MutedText> (archived)</MutedText> : null}
              </span>
              <span>{shortenAddress(sub.subaccount)}</span>
            </SubaccountName>
            <MutedText>
              {sub.positions.length} position{sub.positions.length === 1 ? "" : "s"}
            </MutedText>
            <MutedText>↗</MutedText>
          </SubaccountTableRow>
        ))}
      </SubaccountTable>
    </>
  );
}
